import IframeModal from '../../components/iframeModal';
//外链热点操作
function openLink(data) {
  if (!data || JSON.stringify(data) == '[]' || JSON.stringify(data) == '{}') return;
  const { url, openType } = data;
  if (openType == 1) {
    //本窗口
    window.location.href = url;
  } else if (!openType || openType == 2) {
    //新窗口
    window.open(url);
  } else if (openType == 3) {
    //弹窗
    const params = {
      src: data.url,
      wrapper: this.$container.get(0),
    };
    new IframeModal(params);
  } else {
    throw '不支持的连接类型；';
  }
}

export default {
  openLink,
};
